import { render } from "./Home.vue?vue&type=template&id=06fccf18"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=06fccf18&lang=less&scope=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__